import { z } from 'zod'

import {
  WORKSPACE_SECRET_DESCRIPTION_MAX_LENGTH,
  WORKSPACE_SECRET_KEY_MAX_LENGTH,
  WORKSPACE_SECRET_KEY_PATTERN,
  WORKSPACE_SECRET_VALUE_MAX_LENGTH,
} from './secrets.contract'

export const secretKeySchema = z
  .string()
  .min(1)
  .max(WORKSPACE_SECRET_KEY_MAX_LENGTH)
  .regex(WORKSPACE_SECRET_KEY_PATTERN, 'Secret keys must match [A-Z][A-Z0-9_]*')

export const secretValueSchema = z
  .string()
  .min(1)
  .max(WORKSPACE_SECRET_VALUE_MAX_LENGTH)
export const secretDescriptionSchema = z
  .string()
  .max(WORKSPACE_SECRET_DESCRIPTION_MAX_LENGTH)
  .optional()

export const secretMetadataSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  key: secretKeySchema,
  description: z.string().nullable(),
  createdBy: z.string().nullable(),
  updatedBy: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date().nullable(),
})

export type SecretMetadataContract = z.infer<typeof secretMetadataSchema>
